import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/curriculum/')({
  component: lazyRouteComponent(() => import('./-index')),
})
